import {
    faEdit,
    faImages,
    faTrashAlt
  } from '@fortawesome/free-regular-svg-icons'
  import {
    faThumbsDown,
    faThumbsUp,
    faUndo
  } from '@fortawesome/free-solid-svg-icons'
  import { mapActions, mapGetters } from 'vuex'
  
  import ClickConfirm from 'click-confirm'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  
  export default {
    data: () => ({
      loading: true,
      formData: null,
      edit: faEdit,
      trash: faTrashAlt,
      gallery: faImages,
      undo: faUndo,
      thumbsUp: faThumbsUp,
      thumbsDown: faThumbsDown,
      confirmationMessages: {
        title: 'Tem a certeza?',
        yes: 'Sim',
        no: 'Não'
      }
    }),
    components: {
      ClickConfirm,
      FontAwesomeIcon
    },
    computed: {
      ...mapGetters ({
        item: 'form/fields'
      }),
      isUpdateForm () {
        return this.$route.name.includes('Update')
      }
    },
    methods: {
      ...mapActions({
        initForm: 'form/init',
        resetForm: 'form/reset'
      }),
      async getItem () {
        try {
          const response = await this.api.show(this.$route.params.id)
  
          if (response && response.data) {
            this.model = response.data
            this.initForm(this.model)
          } else {
            this.$router.push({ name: 'error404'})
          }
        } catch (e) {
          console.error(e)
        }
      },
      async submit () {
        this.$v.$touch()
  
        if (this.$v.$invalid) {
          this.$toasted.error(this.$t('form.error'))
          return
        }
  
        const response = await this.api[this.isUpdateForm ? 'update' : 'create'](this.model)
        
        if (this.isUpdateForm && this.hasMetas) {
          this.updateMetas()
        }
  
        if (response && response.data) {
          let item = this.$t('messages.item')
  
          if (response.data.title && response.data.title.pt !== null) {
            item = response.data.title.pt ?? response.data.title
          } else if (response.data.name && response.data.name.pt !== null) {
            item = response.data.name.pt ?? response.data.name
          }
  
          this.$toasted.success(this.$t(this.isUpdateForm ? 'messages.updated' : 'messages.created', { item }))
  
          if (!this.isUpdateForm) {
            this.$router.push({ name: this.$route.name.replace('Create', 'Update'), params: { id: response.data.id } })
          }
  
        } else if (response && response.response && response.response.data && response.response.data.errors) {
          this.$toasted.error(this.translateErrorMessage(response.response.data.errors))
          return [this.$toasted.error(this.translateErrorMessage(response.response.data.errors))]
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
          return[this.$toasted.error(this.$t('messages.unknown_error'))]
        }

        return []
      },
      translateErrorMessage (errors) {
        // @TODO Improve this for the end result to be more non-tech friendly
        return Object.entries(errors)
          .map(item => item[1])
          .join(' ')
      },
      setImage (file) {
        this.$set(this.model, 'file', file)
      }
    },
    beforeDestroy () {
      this.resetForm()
    }
  }
  